import styled from "@emotion/styled";
import type { FC } from "react";

export const PoolLabelHeader: FC = () => (
  <PoolLabelHeaderContainer>
    <span>Pool</span>
    <span>Value of Your Position</span>
  </PoolLabelHeaderContainer>
);

const PoolLabelHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  color: #b2b2b2;
  font-size: 14px;
  line-height: 22px;
`;
